<div class="arrowBtn d-none d-md-inline">
  <a (click)="goBack()" class="btn btn-outline-dark">
    <i class="bi bi-arrow-left arrowIcon"></i>
  </a>
</div>

<div *ngIf="idsystem > 0; else errorBlock" class="container fullPage" style="min-height: 72vh;">
  <div class="row justify-content-center align-items-center mt-2 p-2">
    <div class="col-6 text-center">
      <span class="systemName inline-bordered">{{systemInfo?.system_name}}</span>
    </div>
  </div>

  <div class="row justify-content-center align-items-center p-2">
    <div class="col-12 text-center">
      <span
        *ngIf="systemInfo?.system_description != null && systemInfo?.system_description != ''; else addDescriptionBlock"
        style="font-size: medium; font-style: italic;">{{systemInfo?.system_description}}</span>
      <ng-template #addDescriptionBlock>
        <span style="font-size: medium; font-style: italic;">{{"SYSTEM.OVERVIEW.ADD" | translate}}</span>
      </ng-template>
      <button type="button" class="btn btn-sm btn-outline-dark ms-2" data-bs-toggle="modal"
        data-bs-target="#descriptionModal">
        <i class="bi bi-pencil"></i>
      </button>
    </div>
  </div>

  <div class="modal fade" id="descriptionModal" tabindex="0" aria-labelledby="descriptionModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="descriptionModalLabel">{{"SYSTEM.OVERVIEW.CHANGEDESCRIPTION" | translate}}
          </h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <textarea type="text" [value]="systemInfo?.system_description" style="width: 100%;" #newDescription>
                    </textarea>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{"SYSTEM.OVERVIEW.DISMISS" |
            translate}}</button>
          <button type="button" class="btn btn-primary" (click)="modifyDescription(newDescription.value)"
            data-bs-dismiss="modal">{{"SYSTEM.OVERVIEW.SAVE" | translate}}</button>
        </div>
      </div>
    </div>
  </div>

  <!-- SYSTEM DATA -->
  <div class="row justify-content-center p-1 p-lg-4">
    <div class="col-12 col-md-6 mt-2">
      <div class="card">
        <h5 class="card-header blueBg">{{"SYSTEM.OVERVIEW.SYSTEMDATA" | translate}}</h5>
        <div class="card-body">
          <div *ngIf="systemInfo && systemInfo?.customerInfo?.length! > 1; else systemBlock">
            <ul class="list-unstyled">
              <li class="listElement">
                <i class="bi bi-circle-fill" style="font-size: large;"
                  [ngStyle]="{'color':  '#'+systemInfo.status?.color}">
                </i>
                <span *ngIf="systemInfo?.status" style="margin-left: 1rem;">{{systemInfo.status?.name}}</span>
                <span *ngIf="!systemInfo?.status" style="margin-left: 1rem;">Status not available</span>
              </li>
              <!-- <li class="listElement">
                <span class="listTitle">{{"SYSTEM.OVERVIEW.CUSTOMERNAME" | translate}}:</span><br>
                <span class="listDescription">{{systemInfo.customerInfo}}</span>
              </li> -->
              <li class="listElement">
                <span class="listTitle">{{"SYSTEM.OVERVIEW.INSTALLATIONSITE" | translate}}:</span><br>
                <span class="listDescription">{{systemInfo.installationSite}}</span>
              </li>
              <li class="listElement">
                <span class="listTitle">{{"SYSTEM.OVERVIEW.SYSTEMINFO" | translate}}:</span><br>
                <ul style="list-style-type: circle;">
                  <li>
                    <span class="listDescription">
                      {{"SYSTEM.OVERVIEW.INVERTERNUMBER" | translate}}: {{systemInfo.devicesInfo.num_inverter}}
                    </span>
                  </li>
                  <li>
                    <span class="listDescription">
                      {{"SYSTEM.OVERVIEW.BATTERYNUMBER" | translate}}: {{systemInfo.devicesInfo.num_batteries}}
                    </span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <ng-template #systemBlock class="mt-4 p-2 text-center">
            <span class="mt-2">{{"SYSTEM.OVERVIEW.ENABLEFUNC" | translate}}</span>
          </ng-template>
        </div>
        <div class="card-footer blueBg text-center" *ngIf="systemInfo?.status">
          <button *ngIf="systemInfo?.status!.id == 1 || systemInfo?.status!.id == 3; else readOnlyBlock"
            class="btn btn-outline-dark btn-light me-2" (click)="modifySystem()">
            {{"SYSTEM.OVERVIEW.MODIFYDATA" | translate}}
          </button>
          <ng-template #readOnlyBlock>
            <button class="btn btn-outline-dark btn-light ms-2" (click)="viewSystem()">
              {{"SYSTEM.OVERVIEW.VIEWDATA" | translate}}
            </button>
          </ng-template>
        </div>
      </div>
    </div>

    <!-- WARRANTY -->
    <div class="col-12 col-md-6 mt-2" *ngIf="systemInfo?.status?.id == 15;">
      <div class="card">
        <h5 class="card-header greenBg">{{"SYSTEM.OVERVIEW.WARRANTYINVERTER" | translate}}</h5>
        <div class="card-body row pb-0 custom-scroll-container">
          <ng-container *ngFor="let inverter of warrantyInverterStatus">
            <div *ngIf="inverter.warranty_valid != null" class="col-12 col-xl-6 mb-3">
              <span>
                <span style="font-weight: bold; border-bottom: 1px solid lightgray;">{{"SYSTEM.OVERVIEW.SERIALNUMBER" |
                  translate}}: </span><br>
                <span class="ms-2">{{inverter.sn}}</span>
              </span><br>
              <span>
                <span style="font-weight: bold; border-bottom: 1px solid lightgray;">{{"SYSTEM.OVERVIEW.WARRANTYSTATUS"
                  | translate}}: </span><br>
                <span class="ms-2">{{inverter.warranty_str}}</span>
              </span>
            </div>
          </ng-container>

          <!-- <p style="margin-top: 1rem;">
            <span class="listTitle">{{"SYSTEM.OVERVIEW.WARRANTYSTATUS" | translate}}: </span><br>
          </p>
          <p class="paragraph" *ngIf="systemInfo?.status?.id == 15; else warrantyBlock">
            <span *ngIf="systemInfo?.status?.warranty_extend == 1; else notExtendedBlock">
              {{"SYSTEM.OVERVIEW.EXTENDED" | translate}}
            </span><br><br>
            <ng-template #notExtendedBlock>
              <span>{{"SYSTEM.OVERVIEW.NOTEXTENDED" | translate}}</span><br>
            </ng-template>

            <span *ngIf="product_systemweco == 3; else notWecoBlock">
              {{"SYSTEM.OVERVIEW.EXTENDEDINFO" | translate}}
            </span>
            <ng-template #notWecoBlock>
              <span>
                {{"SYSTEM.OVERVIEW.NOTEXTENDEDINFO" | translate}}
              </span><br>
            </ng-template>
          </p>
          <ng-template #warrantyBlock>
            <p class="paragraph">
              {{"SYSTEM.OVERVIEW.WARRANTYERROR" | translate}}<br>
              <span style="font-weight: bold;">
                {{"SYSTEM.OVERVIEW.ACTUALSTATE" | translate}}:<br>
              </span>
              <i class="bi bi-circle-fill mt-2" style="font-size: large;"
                [ngStyle]="{'color':  '#'+systemInfo?.status?.color}">
              </i>
              {{systemInfo?.status?.name}}
            </p>
          </ng-template> -->
        </div>
        <div class="card-footer greenBg text-center">
          <button class="btn btn-outline-dark btn-light" (click)="viewWarranty()" disabled>
            {{"SYSTEM.OVERVIEW.WARRANTYINFO" | translate}}
          </button>
        </div>
      </div>
    </div>

  </div>

  <!-- TICKET -->
  <div class="row justify-content-center p-1 ps-lg-4 pe-lg-4" *ngIf="systemInfo?.status?.id == 15;">
    <div class="col-12 mt-2">
      <app-ticket-list [idsystem]="idsystem" [ticketList]="ticketList"></app-ticket-list>
    </div>
  </div>
  <!-- <div *ngIf="false" class="row justify-content-center align-items-center mt-2 p-1 p-lg-4">
        <div class="col-12">
            <div class="card">
                <h5 class="card-header orangeBg">{{"SYSTEM.OVERVIEW.TICKETS" | translate}}</h5>
                <div class="card-body">
                    <span style="font-weight: bold;">{{"SYSTEM.OVERVIEW.LATESTREQUESTS" | translate}}:</span>
                    <ul *ngFor="let ticket of systemTickets" class="list-unstyled">
                        <li>
                            <div class="card" (click)="goToTicket(ticket.id)">
                                <div class="card-body">
                                    <div class="card-text">
                                        <div *ngIf="isTicket; else ticketBlock" class="row justify-content-center">
                                            <div class="col-12 col-lg-4 text-start">
                                                <span style="font-weight: bold;">{{"SYSTEM.OVERVIEW.TITLE" | translate}}: </span>
                                                <span>{{ticket.title}}</span>
                                            </div>
                                            <div class="col-12 col-md-6 col-lg-4 mt-md-4 mt-lg-0 text-center">
                                                <span style="font-weight: bold;">{{"SYSTEM.OVERVIEW.DATE" | translate}}: </span>
                                                <span>{{ticket.date_ticket}}</span>
                                            </div>
                                            <div class="col-12 col-md-6 col-lg-4 mt-md-4 mt-lg-0 text-end">
                                                <span style="font-weight: bold;">{{"SYSTEM.OVERVIEW.STATUS" | translate}}: </span>
                                                <span>
                                                    {{ticket.status}}
                                                    <i class="bi bi-circle-fill" [ngClass]="{
                                                            'text-success': ticket.status === 'Solved',
                                                            'text-danger': ticket.status === 'Not Solved',
                                                            'text-warning': ticket.status === 'Waiting for approval'}">
                                                    </i>
                                                </span>
                                            </div>
                                            <div class="col-12">
                                                <span style="font-weight: bold;">{{"SYSTEM.OVERVIEW.DESCRIPTION" | translate}}: </span>
                                                <span>
                                                    {{ticket.description}}

                                                </span>
                                            </div>
                                        </div>
                                        <div class="row justify-content-center">
                                            <ng-template #ticketBlock>
                                                {{"SYSTEM.OVERVIEW.NOTICKETSAVAILABLE" | translate}}
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="card-footer orangeBg text-center">
                    <div class="row justify-content-center">
                        <div class="col-12 mt-1" [ngClass]="{'col-sm-6': isTicket}">
                            <div class="btn btn-outline-dark btn-light" (click)="newTicket()">{{"SYSTEM.OVERVIEW.ADDTICKET" | translate}}</div>
                        </div>
                        <div class="col-12 col-sm-6 mt-1">
                            <div *ngIf="isTicket" class="btn btn-outline-dark btn-light" (click)="ticketsListSystem()">
                                {{"SYSTEM.OVERVIEW.TICKETLIST" | translate}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

  <div class="row justify-content-center align-items-center mt-2 p-1 p-lg-4" *ngIf="false">
    <div class="col-12">
      <div class="card">
        <h5 class="card-header yellowBg">{{"SYSTEM.OVERVIEW.RMA" | translate}}</h5>
        <div class="card-body">
          <div *ngIf="!isRma">
            <h5 class="card-title">{{"SYSTEM.OVERVIEW.NORMA" | translate}}</h5>
            <p class="card-text">{{"SYSTEM.OVERVIEW.PRESSFORRMA" | translate}}.</p>
          </div>
          <div *ngIf="isRma">
            <h5 class="card-title">{{"SYSTEM.OVERVIEW.RMAAVAILABLE" | translate}}</h5>
            <p class="card-text">{{"SYSTEM.OVERVIEW.OLDRMA" | translate}}.</p>
          </div>
        </div>
        <div class="card-footer yellowBg text-center">
          <div href="#" class="btn btn-outline-dark btn-light">{{"SYSTEM.OVERVIEW.NEWRMA" | translate}}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #errorBlock class="mt-4 p-2 text-center">
  <h1>{{"SYSTEM.OVERVIEW.LOADINGERROR" | translate}}</h1><br>
  <h3 class="mt-4">{{"SYSTEM.OVERVIEW.REFRESH" | translate}}</h3>
</ng-template>
